import router from "@/plugins/router"

export default new class RouteRegister {
    handle(routes) {
        routes.forEach(route => {
            router.addRoute(route)
        })
    }
}